import { LoadingController, AlertController, IonInputOtp } from '@ionic/angular';
import { UserService } from 'app/services/user.service';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

@Component({
    selector: 'app-otp-prompt',
    templateUrl: './otp-prompt.component.html',
    styleUrls: ['./otp-prompt.component.scss'],
    standalone: false
})
export class OtpPromptComponent
{
	@Input() allowRememberDevice: boolean;
    @Input() otpSecurityForceEmailOtp: boolean = false;
	@Input() emailOtpAddress: string = '';
	@Output() codeCompleted = new EventEmitter<string>();
	@Output() deviceRemembered = new EventEmitter<boolean>();
	@Output() codeEmailed = new EventEmitter<string>();

	rememberDevice: boolean = false;
	requestEmailOtp: boolean = false;
	obfuscatedEmail: string = '';

	@ViewChild('inputOtp') inputOtp !: IonInputOtp;

	constructor(
		private userService: UserService,
		private loadingController: LoadingController,
		private alertController: AlertController
	) { }

	ionViewDidLoad()
	{
        if (this.inputOtp && this.inputOtp.setFocus) {
            this.inputOtp.setFocus(0); // Focus the first box
        }
	}

	onCodeChanged(code: string)
	{
	}

	async onCodeCompleted(code: string)
	{
		this.codeCompleted.emit(code);
	}

	allowRememberDeviceToggled(ev: any)
	{
		this.deviceRemembered.emit(ev);
	}

	async emailOtp()
	{
		//prompt user to save
		const alert = await this.alertController.create({
			header: "Don't have code",
			message: "Do you want to email a one-time passcode to your account email address?",
			buttons: [
				{
					text: 'Cancel',
					role: 'cancel',
					cssClass: 'primary',
					handler: () =>
					{
						//do nothing
						return;
					}
				},
				{
					text: 'Send email code',
					cssClass: 'danger',
					handler: () =>
					{
						this.sendEmailOtp();
					}
				}
			]
		});

		await alert.present();
	}

	async sendEmailOtp()
	{

		const loading = await this.loadingController.create({
			message: 'Requesting email one-time passcode...',
			duration: 60000
		});
		await loading.present();


		const deviceId = await this.userService.getDeviceId();

		const request = this.emailOtpAddress
			? this.userService.requestEmailChangeOtp(deviceId, this.emailOtpAddress)
			: this.userService.requestEmailOtp(deviceId);

		request.subscribe
			({
				next: x =>
				{
					console.debug(x);
					this.obfuscatedEmail = x.value;
					this.userService.presentToast(`A one-time passcode was sent to ${this.obfuscatedEmail}`, 'secondary');
					this.codeEmailed.emit(this.obfuscatedEmail);
					loading.dismiss();
				},
				error: err =>
				{
					// console.log(err);
					loading.dismiss();
					this.userService.handleError(err);
				}
            });
	}

    public focusInput() {
        setTimeout(() => {
            if (this.inputOtp && this.inputOtp.setFocus) {
                this.inputOtp.setFocus(0);
            }
        }, 50);
    }
}
